export default class Handler {
  handlesError(error) {
    const statusCode = error?.status ?? error?.data?.status
    
    switch (statusCode) {
      case 200:
        let errorMsg = '';
        const dataResponse = error?.data?.retorno

        if (dataResponse && dataResponse.length) {
          error.data.retorno.forEach(error => {
            errorMsg += `${error.msgErro}\n`
          });
        }

        return this.defaultError(errorMsg);
      default:
        this.defaultError();
    }
  }

  defaultError(message = '') {
    if (!message) {
      return 'Não foi possível realizar a operação.'
    }

    return message
  }
}